import * as types from "./types";
import { REQUEST_STATUSES } from "../../../constants/requestStatuses";
import { ExperienceService } from "../../../services";

export const getCurrentExperiences = (propertyId, experienceId) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_CURRENT_EXPERIENCES_REQUEST_STATUS,
      payload: {
        status: REQUEST_STATUSES.LOADING,
        experience: {},
        experienceId,
      },
    });
    const { resp, status, err } = await ExperienceService.getExperience(propertyId, experienceId);
    dispatch({
      type: types.GET_CURRENT_EXPERIENCES,
      payload: {
        experienceId,
        experience: resp || {},
        status,
        err,
        noResults: !resp,
      },
    });
  };
};

export const resetCurrentExperiences = (experienceId) => {
  return (dispatch) => {
    dispatch({
      type: types.RESET_CURRENT_EXPERIENCES,
      payload: { experienceId: experienceId || null },
    });
  };
};
